<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { embedCode } from './fieldCatalog';

const { t } = useI18n();

const dialogRef = ref(null);
const publicKey = ref('');

const code = computed(() =>
  publicKey.value ? embedCode(publicKey.value, window.location.origin) : ''
);

const copy = async () => {
  await navigator.clipboard.writeText(code.value);
  useAlert(t('FORM_BUILDER.EMBED.COPIED'));
};

const open = key => {
  publicKey.value = key;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('FORM_BUILDER.EMBED.TITLE')"
    :description="t('FORM_BUILDER.EMBED.DESCRIPTION')"
    :show-confirm-button="false"
    :cancel-button-label="t('FORM_BUILDER.BACK')"
    width="2xl"
  >
    <div class="flex flex-col gap-3">
      <pre
        class="p-3 m-0 overflow-x-auto text-xs rounded-lg bg-n-alpha-2 text-n-slate-12 whitespace-pre-wrap break-all"
        >{{ code }}</pre
      >
      <p class="m-0 text-xs text-n-slate-11">
        {{ t('FORM_BUILDER.EMBED.NOTE') }}
      </p>
      <Button
        class="self-start"
        icon="i-lucide-copy"
        :label="t('FORM_BUILDER.EMBED.COPY')"
        @click="copy"
      />
    </div>
  </Dialog>
</template>
